import * as datefns from 'date-fns'
import ApiBase from './Api'
import {
    GetInstrumentByIdRequest,
    GetInstrumentListRequest,
    GetInstrumentTradesRequest,
    GetInstrumentTradesResponse,
    PatchInstrumentsRequest,
} from '@finance-lab/utils/types'

const INSTRUMENT_API_PATHS = {
    INSTRUMENT: (id: string) => `/instruments/${id}`,
    TRADES: (id: string) => `/instruments/${id}/trades`,
}

export class InstrumentApi extends ApiBase {
    async *getTrades(id: string) {
        const result: GetInstrumentTradesResponse = {
            right: {},
            unit: {},
            share: [],
        }
        const startTime = performance.now()
        let isDone
        let page = 1

        while (!isDone) {
            const trades = await this._getRequest<GetInstrumentTradesRequest>(
                INSTRUMENT_API_PATHS.TRADES(id) + `?page=${page}`,
            )

            if (!trades.share.length) {
                isDone = false
                break
            }

            const isFirstRun = result.share.length === 0

            result.share.unshift(...trades.share)

            for (const type of ['right', 'unit'] as Array<keyof Omit<typeof trades, 'share'>>) {
                for (const key in trades[type]) {
                    if (!result[type][key]) {
                        result[type][key] = []
                    }

                    result[type][key].unshift(...trades[type][key])
                }
            }

            if (isFirstRun) {
                console.debug('Fetched trades in', performance.now() - startTime)
            }

            yield { ...result }

            page++
        }

        return result
    }

    async getTradesStatsByEndingDate(instrumentId: string, endDate: Date, numberOfDays: number) {
        if (!instrumentId) {
            return null
        }

        const response = await this._getRequest<GetInstrumentByIdRequest>(
            INSTRUMENT_API_PATHS.INSTRUMENT(instrumentId),
            {
                queryParameters: {
                    endDate: datefns.format(endDate, 'yyyy-MM-dd'),
                    numberOfDays: numberOfDays,
                },
            },
        )

        return response
    }

    async getDelistedInstruments() {
        const response = await this._getRequest<GetInstrumentListRequest>('/instruments', {
            queryParameters: { listing: 'delisted' },
        })

        return response
    }

    async update(instrumentToUpdate: { id: string } & PatchInstrumentsRequest['Body']) {
        if (!instrumentToUpdate.id) {
            return null
        }

        const response = await this._patchRequest<PatchInstrumentsRequest>(
            INSTRUMENT_API_PATHS.INSTRUMENT(instrumentToUpdate.id),
            instrumentToUpdate,
        )

        return response
    }
}
